import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import 'react-modal-video/css/modal-video.css'
import 'animate.css/animate.min.css';
import '../src/assets/css/fontawesome.min.css';
import '../src/assets/css/custom.css';
import '../src/assets/css/style.css';
import Routers from './Routers';
import PreLoader from './components/others/PreLoader';
import WhatsAppChat from './components/others/WhatsAppChat';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { ScrollToTop } from 'react-simple-scroll-up';

let hasLoadedOnce = false;

function App() {
  //  Preloader
  const [isLoading, setIsLoading] = useState(!hasLoadedOnce);

  useEffect(() => {
    if (!hasLoadedOnce) {
      hasLoadedOnce = true;
      
      // Function to wait for all images to load
      const waitForImages = (): Promise<void> => {
        return new Promise((resolve) => {
          let loadHandler: (() => void) | null = null;
          
          const checkImages = () => {
            // Remove event listener if it was added
            if (loadHandler) {
              window.removeEventListener('load', loadHandler);
            }
            
            // Use requestAnimationFrame to batch DOM reads and avoid forced reflows
            requestAnimationFrame(() => {
              const images = Array.from(document.querySelectorAll('img'));
              
              if (images.length === 0) {
                resolve();
                return;
              }

              const imagePromises = images.map((img) => {
                // Check if image is already loaded (batch this read)
                const isComplete = img.complete;
                const hasNaturalHeight = img.naturalHeight !== 0;
                
                if (isComplete && hasNaturalHeight) {
                  return Promise.resolve();
                }
                
                // Otherwise wait for load or error
                return new Promise<void>((imgResolve) => {
                  const onLoad = () => {
                    img.removeEventListener('load', onLoad);
                    img.removeEventListener('error', onError);
                    imgResolve();
                  };
                  const onError = () => {
                    img.removeEventListener('load', onLoad);
                    img.removeEventListener('error', onError);
                    imgResolve(); // Resolve even on error to not block preloader
                  };
                  img.addEventListener('load', onLoad);
                  img.addEventListener('error', onError);
                });
              });

              Promise.all(imagePromises).then(() => resolve());
            });
          };

          // Give React time to render the DOM first
          setTimeout(() => {
            // Check if window has already loaded
            if (document.readyState === 'complete') {
              // If already loaded, check images directly
              checkImages();
            } else {
              // Otherwise wait for load event
              loadHandler = checkImages;
              window.addEventListener('load', loadHandler);
            }
          }, 100); // Small delay to ensure DOM is rendered
        });
      };

      // Minimum display time for smooth UX (500ms)
      const minDisplayTime = new Promise(resolve => setTimeout(resolve, 500));
      
      // Maximum wait time as fallback (5 seconds)
      const maxWaitTime = new Promise(resolve => setTimeout(resolve, 5000));
      
      // Wait for images to load, but respect min/max times
      Promise.race([
        Promise.all([waitForImages(), minDisplayTime]),
        maxWaitTime
      ]).then(() => {
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      {isLoading && <PreLoader />}
      <div style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
        <Helmet>
          <title>AutoGrid - Hybrid Vehicle Services</title>
          <link rel="shortcut icon" href="/../images/logo/favicon.png"></link>
          <link rel="preload" as="image" href="/images/slider/slider-1.jpg" fetchPriority="high" />
          {/* Load fonts with display=swap - link tag loads in parallel, reducing critical path */}
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Yantramanav:wght@400;500;700;900&display=swap" />
        </Helmet>
        <ScrollToTop symbol={<i className="fa-solid fa-arrow-up"></i>} />
        <WhatsAppChat />
        <Routers />
      </div>
    </>
  )
}

export default App
